import styled, { css } from 'styled-components';
import { IconHelp } from '@tabler/icons-react';
import { getMarginsCss, marginPropsToFilter } from 'utils/getMarginsCss';
import { MarginsProps } from 'types/components/margins';
import { getShouldForwardProp } from 'utils/getShouldForwardProp';
import { AppTooltip, AppTooltipProps } from '../AppTooltip/AppTooltip';

export type AppTooltipQuestionMarkIconProps = MarginsProps & {
    tooltip: React.ReactNode;
    size?: number;
    color?: string;
    overlayStyle?: AppTooltipProps['overlayStyle'];
    overlayInnerStyle?: AppTooltipProps['overlayInnerStyle'];
    placement?: AppTooltipProps['placement'];
};

const StyledIconHelp = styled(IconHelp).withConfig({
    shouldForwardProp: getShouldForwardProp(marginPropsToFilter),
})<Omit<AppTooltipQuestionMarkIconProps, 'tooltip'>>`
    ${(props) => css`
        ${getMarginsCss(props)}
        display: flex;
        align-items: center;
    `}
`;

export const AppTooltipQuestionMarkIcon = ({
    tooltip,
    size = 20,
    overlayStyle,
    overlayInnerStyle,
    placement,
    ...props
}: AppTooltipQuestionMarkIconProps) => (
    <AppTooltip
        tooltip={tooltip}
        overlayStyle={overlayStyle}
        overlayInnerStyle={overlayInnerStyle}
        placement={placement}
    >
        <StyledIconHelp size={size} {...props} />
    </AppTooltip>
);
